export const portfolioData = {
  personal: {
    name: "Jitendra Pisal",
    title: "QA/SDET Leader & Engineering Manager",
    location: "Pune, India",
    email: "jitendra.pisal44@hotmail.com",
    phone: "+91 8208049255",
    linkedin: "https://www.linkedin.com/in/jitendrapisal/",
    github: "https://github.com/onlyforcoding24",
    resumeUrl: "https://customer-assets.emergentagent.com/job_0a6ce8f1-6b13-435d-a4c2-2c0aa22ef223/artifacts/bc5n1uc2_Resume%20-%20Jitendra%20Pisal%20-%2011%20years%20Experience.pdf",
    summary: "11+ years QA/SDET leader specializing in UI, API, and mobile automation using Java, Selenium WebDriver, TestNG, Maven, Jenkins, REST Assured, TypeScript, Playwright and Karate. Built reusable BDD frameworks and CI/CD pipelines. Optimized Selenium Grid parallel runs, cutting execution from 7 hours to 24 minutes.",
    yearsOfExperience: "11+",
    languages: ["English", "Hindi", "Marathi"]
  },
  
  about: {
    description: "Passionate QA/SDET leader with over 11 years of experience in building robust automation frameworks and leading high-performing engineering teams. I specialize in transforming quality assurance processes through innovative automation strategies, CI/CD implementation, and cross-functional leadership. My expertise spans UI, API, and mobile automation, with a proven track record of reducing test execution times by up to 95% and increasing test coverage significantly.",
    highlights: [
      "Led teams of up to 10 engineers across multiple organizations",
      "Reduced test execution from 7 hours to 24 minutes through optimization",
      "Increased test coverage by 80-95% across multiple projects",
      "Reduced production defects by 99% through strategic QA implementation",
      "Best Manager of the Year at BharatPe",
      "Best Performance of the Quarter at LendingClub"
    ]
  },
  
  experience: [
    {
      id: "1",
      company: "LendingClub (Coforge)",
      role: "Test Specialist - Manager",
      duration: "Apr 2024 - Present",
      location: "Pune",
      type: "leadership",
      description: "Leading QA automation strategy across squads, managing team of 8 people containing developers, testers and DevOps.",
      achievements: [
        "Led QA automation strategy, increasing test coverage by 80% and reducing production defects by 99%",
        "Managing team of 8 people (developers, testers, DevOps)",
        "Key decision maker in designing and enhancing systems",
        "Established CI/CD pipelines with parallel execution, cutting regression cycle by 6+ hours",
        "Reduced UAT escalations by 99% through cross-functional collaboration",
        "Improved script reusability by 85% and lowered maintenance by 90%",
        "Introduced AI-driven testing strategies for test case generation"
      ],
      technologies: ["Java", "Selenium WebDriver", "TestNG", "Maven", "Jenkins", "REST Assured", "Docker", "Kafka", "AI Tools", "LLMNotebook", "Gemini"]
    },
    {
      id: "2",
      company: "BharatPe",
      role: "Engineering Manager - QA",
      duration: "Feb 2023 - Apr 2024",
      location: "Pune",
      type: "leadership",
      description: "Managed team of 10 engineers, led entire Merchant pod ensuring quality and code development.",
      achievements: [
        "Managed team of 10 engineers",
        "Built scalable testing automation framework covering UI, API and mobile",
        "Boosted backend API coverage by 95%, reducing incidents by 95%",
        "Reduced release validation by 2 hours for UI/Function Testing",
        "Lowered code issues by 95% across 5 repositories through code reviews",
        "Cut payment failures by 17%, protecting ₹75L GMV monthly",
        "Received 'Best Manager of the Year' award"
      ],
      technologies: ["Java", "Selenium", "REST Assured", "TestNG", "Appium", "Playwright", "TypeScript", "Kafka", "Jenkins"]
    },
    {
      id: "3",
      company: "Meesho",
      role: "SDET IV",
      duration: "Jun 2022 - May 2023",
      location: "Pune",
      type: "technical",
      description: "Led team of 4 people, built testing practices across team.",
      achievements: [
        "Led team of 4 people",
        "Built BDD automation across UI/API/mobile, automating 300-400 test cases",
        "Increased pipeline reliability by 80% through API mocking strategies",
        "Increased test coverage to 88%, reduced critical bugs by 40%"
      ],
      technologies: ["Java", "Selenium WebDriver", "TestNG", "Maven", "Jenkins", "REST Assured", "Cucumber"]
    },
    {
      id: "4",
      company: "Fabric",
      role: "Senior Quality Engineer",
      duration: "Nov 2021 - Jun 2022",
      location: "Pune",
      type: "technical",
      description: "Built API automation framework and implemented REST and web services testing.",
      achievements: [
        "Built API automation framework from scratch",
        "Improved API quality with 95% fewer defects",
        "Reduced mean time to detect by 80% through automated checks"
      ],
      technologies: ["Java", "TestNG", "REST Assured", "Jenkins"]
    },
    {
      id: "5",
      company: "Calsoft India",
      role: "Principal QA Engineer",
      duration: "Nov 2020 - Nov 2021",
      location: "Pune",
      type: "technical",
      description: "Led framework development with TestNG + WebDriver + Maven.",
      achievements: [
        "Enabled 100% faster test authoring and execution",
        "Saved 30hrs/week across teams through Jenkins setup",
        "Reduced reopen rates by 80% through root cause analysis"
      ],
      technologies: ["Java", "Selenium WebDriver", "TestNG", "Maven", "Selenium Grid", "Jenkins"]
    },
    {
      id: "6",
      company: "REI Systems India",
      role: "Software Developer - Test",
      duration: "Jan 2019 - Nov 2020",
      location: "Pune",
      type: "technical",
      description: "Developed automation framework supporting Mobile, Web and API testing.",
      achievements: [
        "Developed Jenkins pipeline for automation across organization",
        "Performed API and performance testing",
        "Built framework supporting Mobile, Web and API testing"
      ],
      technologies: ["Java", "Selenium WebDriver", "REST Assured", "TestNG", "Jenkins", "Appium"]
    }
  ],
  
  skills: {
    leadership: [
      { name: "Team Management", level: 95 },
      { name: "Strategic Planning", level: 90 },
      { name: "Cross-functional Collaboration", level: 92 },
      { name: "Mentoring", level: 95 },
      { name: "Decision Making", level: 90 }
    ],
    technical: [
      { name: "Java", level: 95 },
      { name: "Selenium WebDriver", level: 98 },
      { name: "REST Assured", level: 95 },
      { name: "TestNG", level: 95 },
      { name: "Jenkins CI/CD", level: 90 },
      { name: "Playwright", level: 85 },
      { name: "TypeScript", level: 82 },
      { name: "Appium", level: 85 },
      { name: "Cucumber/BDD", level: 90 },
      { name: "System Design", level: 88 },
      { name: "Docker", level: 80 },
      { name: "Kafka", level: 78 },
      { name: "AI Tools", level: 85 }
    ],
    categories: {
      "Automation Tools": ["Selenium WebDriver", "Playwright", "Appium", "Protractor", "Karate Framework"],
      "Testing Frameworks": ["TestNG", "Cucumber", "JUnit", "Jasmine"],
      "API Testing": ["REST Assured", "Postman", "SOAP UI", "MockServer"],
      "Programming": ["Java", "TypeScript", "JavaScript", "Python", "Apex"],
      "CI/CD & DevOps": ["Jenkins", "GitHub Actions", "Docker", "Selenium Grid"],
      "System & Architecture": ["System Design", "Microservices", "Event-driven Architecture", "Kafka"],
      "AI & Innovation": ["GitHub Copilot", "ChatGPT", "LLMNotebook", "Gemini", "Prompt Engineering"],
      "Version Control": ["Git", "Bitbucket", "GitHub"],
      "Others": ["Maven", "Linux", "Data Structures", "Algorithms"]
    }
  },
  
  projects: [
    {
      id: "1",
      name: "LendingClub - Consumer Platform",
      category: "FinTech",
      description: "Led QA automation for AWS migration of 300+ web services, ensuring zero downtime and implementing AI-driven testing strategies.",
      achievements: [
        "Migrated 300+ web services to AWS with zero failover",
        "Created AI Agent to fix security vulnerabilities across 100+ repos",
        "Implemented performance testing metrics",
        "Set up automation framework for API and UI",
        "Designed scalable systems for high-traffic scenarios"
      ],
      impact: "99% reduction in production defects, 6+ hour reduction in regression cycles",
      technologies: ["Java", "Selenium", "Jenkins", "Docker", "AWS", "AI Tools"]
    },
    {
      id: "2",
      name: "BharatPe - Merchant App & CRM",
      category: "FinTech",
      description: "Built end-to-end automation strategy covering backend, frontend and mobile app for merchant platform.",
      achievements: [
        "Managed 10 engineers across testing and development",
        "Built scalable automation framework using Cucumber and Java",
        "Implemented Playwright framework for internal CRM",
        "Protected ₹75L GMV monthly through payment flow improvements",
        "Provided training on automation and system design best practices"
      ],
      impact: "95% reduction in incidents, 17% reduction in payment failures",
      technologies: ["Java", "Playwright", "TypeScript", "Cucumber", "Appium"]
    },
    {
      id: "3",
      name: "Trading Partner Discovery - SAP Ariba",
      category: "Enterprise",
      description: "Built comprehensive automation framework for SAP Ariba Network with UI and API coverage.",
      achievements: [
        "Built Protractor + TypeScript UI framework",
        "Implemented REST Assured + Spring Boot API automation",
        "Increased coverage by 80%",
        "Reduced execution time by 1 hour",
        "Implemented backend mocking via MockServer"
      ],
      impact: "95% reduction in pre-GA defects",
      technologies: ["Protractor", "TypeScript", "REST Assured", "Spring Boot", "MockServer"]
    },
    {
      id: "4",
      name: "Integrated Mobile App - Barclays",
      category: "Banking",
      description: "Built API automation framework from scratch for banking mobile application.",
      achievements: [
        "Framework with SOAP UI, Postman, REST Assured, and Cucumber",
        "Cut regression validation by 30 minutes",
        "Expanded coverage by 100%",
        "Reduced test flakiness by 95%"
      ],
      impact: "Improved deployment reliability by 100%",
      technologies: ["REST Assured", "Cucumber", "Postman", "SOAP UI"]
    }
  ],
  
  education: {
    degree: "Bachelor of Engineering (E&TC)",
    institution: "Imperial College of Engineering and Research",
    university: "Savitribai Phule Pune University",
    year: "2013",
    location: "Pune"
  },
  
  awards: [
    "Best Manager of the Year - BharatPe",
    "Best Performance of the Quarter - LendingClub"
  ]
};